// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".caseDetails {\n  width: 80%;\n  padding: 50px;\n  border: #1F7FE6 solid 1px;\n}\n", "",{"version":3,"sources":["webpack://src/pages/mobile/cooperate/caseDetails/index.less"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,aAAA;EACA,yBAAA;AACF","sourcesContent":[".caseDetails {\n  width: 80%;\n  padding: 50px;\n  border: #1F7FE6 solid 1px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
